var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Device - "+_vm._s(_vm.device.hash))]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('statistics-chart',{attrs:{"device":_vm.device,"legend":_vm.legend}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }